import React from "react";
import { cx } from "components/crm/ui/uiUtils";

// `tone`: background and text classes, neutral grey by default.
const Badge = ({ tone = "bg-surfaceMuted text-body", children }) => (
  <span
    className={cx(
      "inline-flex max-w-full items-center gap-1 truncate rounded-lg px-3 py-1 text-xs font-semibold leading-4",
      tone
    )}
  >
    {children}
  </span>
);

export default Badge;
